export enum WFXBuyersEnum {
    GAP = "GAP",
    WALMART = "WALMART",
    PVH = "PVH",
    RalphLauren = 'Ralph Lauren',
    "Victoria's Secret" = "Victoria's Secret",
    'Calvin Klein' = 'Calvin Klein',
    'Patagonia' = 'Patagonia',
    'New Balance' = 'New Balance',
    Athleta = 'Athleta',
    Uniqlo = 'Uniqlo',
    "Under Armour" = 'Under Armour',
    Lululemon = 'Lululemon',
    Centric = 'Centric',
    Pink = 'Pink',
    Levis = "Levis",
    Sanmar = 'Sanmar',
}